import { Typography } from "@joonapp/web-shared"

import ChildTabNav from "./ChildTabNav"
import DoterChatPage from "./DoterChatTab"
import ProgressTab from "./ProgressTab"
import SettingsTab from "./SettingsTab"
import PageContentWrapper from "../../../components/pageContentWrapper/PageContentWrapper"
import { ChildTabNavOption } from "../../../types"
import { GetChildStartedContent } from "../GetChildStartedModal"
import useChildTabNavStore from "../hooks/useChildTabNavStore"
import { useIsChildOnboarded } from "../hooks/useIsChildOnboarded"
import useSelectedFamilyMember from "../hooks/useSelectedFamilyMember"

const ChildPage = () => {
  const { selectedTab } = useChildTabNavStore()
  const isChildOnboarded = useIsChildOnboarded()
  const { selectedProfile } = useSelectedFamilyMember()

  if (!selectedProfile) return <></>

  return (
    <div className="w-full mx-auto max-w-[600px] pb-[15vh]">
      <ChildTabNav />
      {isChildOnboarded ? (
        <PageContentWrapper mobileGutter={true}>
          {selectedTab === ChildTabNavOption.PROGRESS && <ProgressTab />}
          {selectedTab === ChildTabNavOption.DOTER_CHATS && <DoterChatPage />}
          {selectedTab === ChildTabNavOption.SETTINGS && <SettingsTab />}
        </PageContentWrapper>
      ) : (
        <div className="flex flex-col gap-4 pt-4">
          <div className="flex flex-row gap-2 mx-auto items-center">
            <img src="/images/avatars/egg.png" alt="" className="h-12" />
            <Typography variant="h3">{selectedProfile?.user.name}</Typography>
          </div>
          <div className=" bg-backgroundPrimary rounded-md border border-borderPrimary max-w-[450px] mx-auto">
            <GetChildStartedContent childId={selectedProfile?.user.id} />
          </div>
        </div>
      )}
    </div>
  )
}

export default ChildPage
